// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"6f9c6b9d","787":"128e3881"}[chunkId] + ".chunk.js";
};